import { Injectable, NgZone } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DialogRef } from "@progress/kendo-angular-dialog";
import { appCommonConstants } from "../../../app.constants";
import { ISignalRHubMessage } from "../../../interfaces/signalR.interfaces";
import { AppAuthService } from "../../../services/auth.service";
import { AppDialogService } from "../../../services/dialog.service";
import { AppEventService } from "../../../services/event.service";
import { AppNotificationService, NotifyType, NotifyTypeInfo } from "../../../services/notification.service";
import { AppSignalRService } from "../../../services/signalR.service";
import { appSessionManagerConstants } from "../session-manager.constants";

@Injectable({
  providedIn: 'root',
})

export class AppSessionManagerInitService {
  constructor(private authService: AppAuthService,
    private dialogService: AppDialogService,
    private eventService: AppEventService,
    private notificationService: AppNotificationService,
    private signalrService: AppSignalRService,
    private translate: TranslateService,
    private zone: NgZone) { }

  private isInited = false;

  /** Inizializzazione */
  public init(): void {
    if (this.isInited) {
      return;
    }
    this.isInited = true;

    // All'init di SignalR, registra il client sull'evento di default sessionManagerNotification
    this.eventService.on(appCommonConstants.events.signalR.initialized).subscribe(() => {
      this.signalrService.listenerSetUp({ name: appCommonConstants.events.signalR.listeners.sessionManagerNotification, filter: false, broadcastEvent: appCommonConstants.events.signalR.listeners.sessionManagerNotification }, true, true);
    });

    this.eventService.on(appCommonConstants.events.signalR.listeners.sessionManagerNotification).subscribe((value: unknown) => {
      const message = value as ISignalRHubMessage;
      let disconnect = false;

      switch (message.key) {
        case appSessionManagerConstants.events.signalR.disconnect: {
          disconnect = true;
          message.message = `<h6 class="text-info"><i class="fas fa-exclamation-circle"></i>&nbsp;${this.translate.instant("MESSAGE.L'amministratore ti ha disconnesso dall'applicazione, dovrai effettuare un nuovo login")}</h6><hr />${message.message}`;
          this.authService.logOut(false);
          break;
        }
        case appSessionManagerConstants.events.signalR.message: {
          // Do null
          break;
        }
        default: {
          throw (`Chiave evento sconosciuta: ${message.key}`);
        }
      }

      this.zone.run(() => { // È necessario che sia eseguito tramite NgZone
        let dialog: DialogRef = this.dialogService.dialogOpen({
          actions: [{ text: this.translate.instant("WORD.CHIUDI"), themeColor: "primary" }],
          cssClassList: disconnect ? ['dialog-danger'] : ['dialog-info'],
          content: `<div>${message.message}</div>`,
          isTitleHtml: true,
          minHeight: 300,
          minWidth: 300,
          title: `<span><i class="fas fa-exclamation-circle"></i>&nbsp;${this.translate.instant('WORD.ATTENZIONE')}</span>`
        });

        // Salvataggio tra le notifiche
        this.notificationService.push({
          data: message.timestamp,
          message: message.message,
          notifyType: NotifyType.BATCH,
          title: "System message",
          typeInfo: disconnect ? NotifyTypeInfo.WARNING : NotifyTypeInfo.INFO,
          username: message.username
        });

        dialog?.result.subscribe((result) => {
          if (result && disconnect) {
            this.authService.gotoLogin();
            return;
          }
        });
      });
    });
  }
}
